import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ProductStorageService {

    constructor(
        private http: HttpClient,
        private global: GlobalDataService
    ) { }



    getProductStorageListService(page: number = 0) {
        let url = "";
        if (page) {
            url = "?page=" + page;
        }
        return this.http.get(this.global.httpUrl + "product-storage" + url);
    }

    getProductStorageByFilter(filter: any[], page = 0,store_id=0,isActive:number=-1) {
        let url = "";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0, url.length - 1);
        if (page) {
            url += "&page=" + page;
        }
        if(store_id){
            url+="&store_id="+store_id;
        }

        let isAvailable: string ="&active="+isActive;
        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl + "product-storage?" + url+isAvailable);
    }

    defectiveProduct(data: any) {
        return this.http.post(this.global.httpUrl + "defective-products", data);
    }

    getDefectiveProductByFilter(filter: any[], page = 0) {
        let url = "";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0, url.length - 1);
        if (page) {
            url += "&page=" + page;
        }
        return this.http.get(this.global.httpUrl + "defective-products?" + url);
    }

    updateProductStorage(data: any, id: any) {
        return this.http.put(this.global.httpUrl + "product-storage/" + id, data);
    }


    // getProductById(id) {
    //        let headers = new Headers(),authtoken = localStorage.getItem('token');
    //       headers.append("Authorization", 'Bearer' + authtoken);
    //       headers.append('X-Requested-With', 'XMLHttpRequest')
    //       headers.append('Content-Type', 'application/json;')
    //      return this.http.get(this.global.httpUrl+"products/"+id,
    //           {
    //            headers: headers
    //           }).map((response: Response) =>response.json())
    //  } 

    // createProduct(data){

    //        let headers = new Headers(),authtoken = localStorage.getItem('token');
    //       headers.append("Authorization", 'Bearer' + authtoken);
    //       headers.append('X-Requested-With', 'XMLHttpRequest');
    //       headers.append('Content-Type', 'application/json;');
    //    ///  headers.append("enctype", "multipart/form-data");


    //      return this.http.post(this.global.httpUrl+"products", data, { headers: headers })
    //                      .map((resp:Response)=>resp.json())
    //                      .catch((error:any) =>{return Observable.throw(error);}); 

    //  }

    // updateProduct(data,id){

    //  let headers = new Headers(),authtoken = localStorage.getItem('token');
    //       headers.append("Authorization", 'Bearer' + authtoken);
    //       headers.append('X-Requested-With', 'XMLHttpRequest')
    //       headers.append('Content-Type', 'application/json;')

    //      return this.http.put(this.global.httpUrl+"products/"+id, data, { headers: headers })
    //                      .map((resp:Response)=>resp.json())
    //                      .catch((error:any) =>{return Observable.throw(error);}); 

    //  } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/product_storages/product-storage.service.ts